import { render, staticRenderFns } from "./EvolutionByInstitutionBar.vue?vue&type=template&id=072cbf6c&"
import script from "./EvolutionByInstitutionBar.vue?vue&type=script&lang=js&"
export * from "./EvolutionByInstitutionBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports